import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-03/lesson-08/task-04";

const task: Slide = {
  title: "How does the number of image sources change for higher orders?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
